(() => {
  if (window.DCCartEngraveTextInstalled) return;
  window.DCCartEngraveTextInstalled = true;

  const TOGGLE_SELECTOR = '[data-engrave-toggle]';
  const EDITOR_SELECTOR = '[data-engrave-editor]';
  const SAVE_SELECTOR = '[data-engrave-save]';
  const CANCEL_SELECTOR = '[data-engrave-cancel]';
  const INPUT_SELECTOR = '[data-engrave-input]';
  const FONT_SELECTOR = '[data-engrave-font]';
  const FONT_WRAP_SELECTOR = '[data-engrave-font-wrap]';
  const STATUS_SELECTOR = '[data-engrave-status]';
  const PROPS_SELECTOR = '[data-engrave-properties]';
  const V3_EDIT_SELECTOR = '[data-live-preview-v3-edit]';

  const getChangeUrl = () => {
    const route = window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change';
    return route.endsWith('.js') ? route : `${route}.js`;
  };

  const setStatus = (editor, message) => {
    const status = editor.querySelector(STATUS_SELECTOR);
    if (status) {
      status.textContent = message || '';
    }
  };

  const toggleEditor = (editor, show) => {
    if (!editor) return;
    editor.hidden = !show;
    if (show) {
      updateFontVisibility(editor);
      const input = editor.querySelector(INPUT_SELECTOR);
      if (input) {
        input.focus();
        input.select();
      }
    } else {
      setStatus(editor, '');
    }
  };

  const toPlainProperties = (properties) => {
    if (Array.isArray(properties)) {
      return properties.reduce((acc, entry) => {
        if (Array.isArray(entry) && entry.length >= 2) {
          acc[entry[0]] = entry[1];
        }
        return acc;
      }, {});
    }
    if (properties && typeof properties === 'object') {
      return Object.assign({}, properties);
    }
    return {};
  };

  const normalizeProperties = (properties, engraveText, engraveFont) => {
    const updated = toPlainProperties(properties);

    delete updated['Engrave text'];
    delete updated['Engrave Text'];

    if (engraveText) {
      updated['Engrave Text'] = engraveText;
      if (engraveFont) {
        updated.Font = engraveFont;
      }
    }

    delete updated._preview_image_url;
    delete updated._preview_image_thumbnail_url;

    return updated;
  };

  const updateLineItem = async (lineKey, lineNumber, properties) => {
    const payload = lineNumber
      ? { line: Number(lineNumber), properties }
      : { id: lineKey, properties };
    const response = await fetch(getChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Cart update failed');
    }

    return response.json();
  };

  const handleSave = async (editor) => {
    const input = editor.querySelector(INPUT_SELECTOR);
    const fontSelect = editor.querySelector(FONT_SELECTOR);
    const propsEl = editor.querySelector(PROPS_SELECTOR);

    if (!input || !propsEl) return;

    const engraveText = input.value.trim();
    const engraveFont = fontSelect ? fontSelect.value : '';
    let properties = {};
    try {
      properties = JSON.parse(propsEl.textContent || '{}');
    } catch (error) {
      console.error(error);
    }
    const lineKey = editor.getAttribute('data-line-key');
    const lineNumber = editor.getAttribute('data-line-number');

    if (!lineKey && !lineNumber) return;

    setStatus(editor, 'Saving...');
    editor.querySelectorAll('button').forEach((button) => (button.disabled = true));
    setCartItemLoading(lineKey, lineNumber, true);

    try {
      const updatedProperties = normalizeProperties(properties, engraveText, engraveFont);
      const cartData = await updateLineItem(lineKey, lineNumber, updatedProperties);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-engrave', cartData });
      }

      setStatus(editor, 'Updated.');
      toggleEditor(editor, false);
    } catch (error) {
      console.error(error);
      setStatus(editor, 'Update failed. Please try again.');
      setCartItemLoading(lineKey, lineNumber, false);
    } finally {
      editor.querySelectorAll('button').forEach((button) => (button.disabled = false));
    }
  };

  const setCartItemLoading = (lineKey, lineNumber, isLoading) => {
    let cartItem = null;
    if (lineKey) {
      const selector = `[data-line-key="${escapeSelector(lineKey)}"]`;
      cartItem = document.querySelector(selector);
    }
    if (!cartItem && lineNumber) {
      cartItem = document.getElementById(`CartItem-${lineNumber}`);
    }
    if (!cartItem) return;

    cartItem.classList.toggle('cart-item--preview-loading', isLoading);
    const imageContainer = cartItem.querySelector('.cart-item__image-container');
    if (!imageContainer) return;

    let spinner = imageContainer.querySelector('.engrave-loading-spinner');
    if (isLoading) {
      if (!spinner) {
        spinner = document.createElement('span');
        spinner.className = 'engrave-loading-spinner';
        spinner.setAttribute('aria-hidden', 'true');
        imageContainer.append(spinner);
      }
    } else if (spinner) {
      spinner.remove();
    }
  };

  const escapeSelector = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/[^\w-]/g, '\\$&');
  };

  const updateFontVisibility = (editor) => {
    const input = editor.querySelector(INPUT_SELECTOR);
    const wrap = editor.querySelector(FONT_WRAP_SELECTOR);
    if (!input || !wrap) return;

    const hasText = input.value.trim().length > 0;
    wrap.hidden = !hasText;
  };

  document.addEventListener('click', (event) => {
    const v3EditButton = event.target.closest(V3_EDIT_SELECTOR);
    if (v3EditButton) {
      event.preventDefault();
      const editUrl = v3EditButton.getAttribute('data-edit-url');
      const sessionId = v3EditButton.getAttribute('data-edit-session');
      if (!editUrl || !sessionId) return;

      const targetUrl = new URL(editUrl, window.location.origin);
      const currentUrl = new URL(window.location.href);
      targetUrl.searchParams.set('preview_v3', '1');
      targetUrl.searchParams.set('edit_preview_session', sessionId);
      const groupId = v3EditButton.getAttribute('data-edit-group');
      const lineKey = v3EditButton.getAttribute('data-edit-key');
      if (groupId) targetUrl.searchParams.set('edit_cart_group', groupId);
      if (lineKey) targetUrl.searchParams.set('edit_cart_key', lineKey);
      const focus = v3EditButton.getAttribute('data-edit-focus');
      if (focus) targetUrl.searchParams.set('edit_focus', focus);
      ['preview_theme_id', 'view'].forEach((parameter) => {
        const value = currentUrl.searchParams.get(parameter);
        if (value) targetUrl.searchParams.set(parameter, value);
      });
      v3EditButton.setAttribute('aria-busy', 'true');
      if (v3EditButton.tagName === 'BUTTON') {
        v3EditButton.disabled = true;
        v3EditButton.textContent = 'Opening design…';
      }
      window.location.assign(targetUrl.pathname + targetUrl.search);
      return;
    }

    const toggleButton = event.target.closest(TOGGLE_SELECTOR);
    if (toggleButton) {
      event.preventDefault();
      const editor = toggleButton.closest('.cart-item__details')?.querySelector(EDITOR_SELECTOR);
      toggleEditor(editor, true);
      return;
    }

    const saveButton = event.target.closest(SAVE_SELECTOR);
    if (saveButton) {
      event.preventDefault();
      const editor = saveButton.closest(EDITOR_SELECTOR);
      if (editor) {
        handleSave(editor);
      }
      return;
    }

    const cancelButton = event.target.closest(CANCEL_SELECTOR);
    if (cancelButton) {
      event.preventDefault();
      const editor = cancelButton.closest(EDITOR_SELECTOR);
      toggleEditor(editor, false);
    }
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest(INPUT_SELECTOR);
    if (!input) return;

    const editor = input.closest(EDITOR_SELECTOR);
    updateFontVisibility(editor);
  });
})();
